import React from "react";
import { Grid, Stack, Typography, Box } from "@mui/material";
import img1 from "./img/Chatbot builder101.png";
import img2 from "./img/contact manage101.png";
import img3 from "./img/blue tick 101.png";
import img4 from "./img/WhatsApp Form101.png";
import img5 from "./img/Secure data101.png";
import img6 from "./img/broadcasting101.png";
import img7 from "./img/analytics54.png";

const MobileCard = ({ card_img, card_title, card_description, bg, index }) => {
  const isLastCard = index === 6;
  return (
    <Box
      sx={{
        background: bg.replace(/#([A-Fa-f0-9]{6})/, "#$18C"),
        borderRadius: "16px",
        padding: "12px",
        margin: isLastCard ? "12px auto 28px auto" : "10px auto",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.15)",
        transition: "transform 0.3s ease, background 0.3s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          background: bg.replace(/#([A-Fa-f0-9]{6})/, "#$17F"),
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "120px",
        width: "100%",
        maxWidth: "340px",
      }}
    >
      {/* Left side: Image inside a smaller cardbox */}
      <Box
        sx={{
          width: "90px",
          height: "90px",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(255, 255, 255, 0.15)",
          backdropFilter: "blur(4px)", // Glassmorphism for inner cardbox
          WebkitBackdropFilter: "blur(4px)",
          boxShadow: "inset 0 2px 8px rgba(0, 0, 0, 0.15)", // Inset shadow for recessed effect
          border: "1px solid rgba(255, 255, 255, 0.4)",
          padding: "5px", // Space between the inner cardbox and the image
        }}
      >
        <Box
          sx={{
            width: "80px", 
            height: "80px",
            borderRadius: "8px",
            overflow: "hidden",
            flexShrink: "0",
            filter: "brightness(0.9)", 
          }}
        >
          <img
            src={card_img}
            alt={card_title}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Box>
      </Box>

      {/* Middle: Title and Description */}
      <Box
        sx={{
          flexGrow: 1,
          textAlign: "left",
          pl: 2,
          pr: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: "1.1rem",
            fontWeight: 600,
            lineHeight: 1.2,
            color: "rgba(0, 0, 0, 0.8)",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            display: "-webkit-box",
            // WebkitLineClamp: 2, // Allow up to 2 lines for the title
            WebkitBoxOrient: "vertical",
          }}
        >
          {card_title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.95rem",
            color: "rgba(0, 0, 0, 0.6)",
            mt: 0.5,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            display: "-webkit-box",
            // WebkitLineClamp: 2, // Allow up to 2 lines for the description
            WebkitBoxOrient: "vertical",
          }}
        >
          {card_description}
        </Typography>
      </Box>
    </Box>
  );
};

const MobileCardComponent = () => {
  const cardData = [
    {
      card_img: img1,
      card_title: "No-code chatbot builder",
      card_description:
        "Build no-code chatbots with an easy drag & drop interface.",
      bg: "#E1EFFF", // Vibrant blue
    },
    {
      card_img: img2,
      card_title: "Smart targeting",
      card_description:
        " Organize audiences with tags and lists for targeted outreach.",
      bg: "#EAFBF1", // Vibrant green
    },
    {
      card_img: img3,
      card_title: "Business verification",
      card_description:
        "Show your brand’s authenticity and reliability with a verified badge",
      bg: "#F5F1EE", // Vibrant brown
    },
    {
      card_img: img4,
      card_title: "Easy form filling",
      card_description:
        "Collect user data through interactive WhatsApp forms.",
      bg: "#e2e9f0", // Vibrant gray
    },
    {
      card_img: img5,
      card_title: "Local data security",
      card_description:
        "Store data locally for enhanced security and compliance.",
      bg: "#e3e9ff", // Vibrant purple
    },
    {
      card_img: img6,
      card_title: "Smart messaging",
      card_description:
        "Send personalized messages and retarget customers effectively.",
      bg: "#EAEFEB", // Vibrant White Lilac
    },
    {
      card_img: img7,
      card_title: "Real-time insights",
      card_description:
        "Get instant visibility into your business performance with live data updates.",
      bg: "#FFE8E1", // Vibrant orange
    },
  ];

  return (
    <Stack sx={{ display: { xs: "flex", sm: "none" }, alignItems: "center" }}>
      <Grid container spacing={0} columns={12}>
        {cardData.map((card, index) => (
          <Grid item xs={12} key={index}>
            <MobileCard
              card_img={card.card_img}
              card_title={card.card_title}
              card_description={card.card_description}
              index={index}
              bg={card.bg}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default MobileCardComponent;